import { createFileRoute } from "@tanstack/react-router";
import AnthemBlueCrossInsurance, {
  config,
} from "@/pages/AnthemBlueCrossInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/anthem-blue-cross-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Anthem Blue Cross California TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anthem Blue Cross coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Anthem Blue Cross California TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anthem Blue Cross coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/anthem-blue-cross-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anthem-blue-cross-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnthemBlueCrossInsurance />;
}
